import { Typography } from "@suraasa/placebo-ui"
import PageContainer from "components/PageContainer"

import { useUserLeadContext } from "./Context"

const LeadBanner = () => {
  const { leadProfile } = useUserLeadContext()
  const { userLead } = leadProfile || {}
  return (
    <div className="h-7 w-full bg-onSurface-900">
      <PageContainer className="h-full text-white">
        <div className="flex h-full items-center justify-between">
          <div>
            <Typography variant="title3">{`${userLead?.fullName}`}</Typography>
          </div>
          <div className="flex flex-col md:flex-row md:items-center md:gap-1">
            <Typography variant="body">{`${userLead?.phoneNumber}`}</Typography>
            <Typography variant="body">{userLead?.email}</Typography>
          </div>
        </div>
      </PageContainer>
    </div>
  )
}

export default LeadBanner
